import type { CSSProperties, ReactNode } from 'react';
import { categoryDescriptionStyle } from './Subtitle';
import { Typography, type TypographyProps } from '@mui/material';

export const fieldDescriptionStyle: CSSProperties = categoryDescriptionStyle;

type TCaptionProps = {
  children?: ReactNode;
  component?: TypographyProps['component'];
};

const Caption = ({ children, component }: TCaptionProps) => {
  return (
    <Typography
      className="blox-caption"
      component={component || 'p'}
      sx={fieldDescriptionStyle}
    >
      {children}
    </Typography>
  );
};

export default Caption;
